export default {"src":"/_next/static/media/monito.8d890f10.svg","height":238,"width":568,"blurWidth":0,"blurHeight":0};